import { SliderSingleProps } from "antd";
import React from "react";
import { StyledSlider } from "./atom";

export function Slider({ className = "", ...props }: SliderSingleProps) {
  return (
    <StyledSlider className={`renderbus-ui--slider ${className}`} {...props} />
  );
}
